import { isValidColor } from '../helpers';

export default {
  props: {
    color: {
      type: String,
      default: null,
      validator: val => isValidColor(val)
    },
  },
  computed: {
    hasColor() {
      return this.color !== null;
    },
  }
};
